import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {
    EmailOtpRegistrationRequest, EmailOtpRegistrationResponse
} from '../protocol/registration-otp-req';

export class EmailOtpRegistration extends HubApiRequest<EmailOtpRegistrationRequest, EmailOtpRegistrationResponse> {
    constructor(url: string, deviceIdentifier: string, data: EmailOtpRegistrationRequest) {
        super(url, HubMethod.EMAIL_OTP_REG, deviceIdentifier, data, uuidv4());
    }
}
